import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ClickableIconLabel from '../../../../../ClickableIconLabel/ClickableIconLabel';
import CreateEditITProcessModalWrapper from '../../../../../EntityCrud/CreateEditITProcessModalWrapper';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';

export default function NewItProcessToolbarButton({label, className, disabled, bodyId, onSaveComplete}) {
	const [showModal, setShowModal] = useState(false);

	return (
		<StyledNewItProcessToolbarButton className={`NewItProcessToolbarButton ${className}`}>
			<ClickableIconLabel
				disabled={disabled}
				text={label}
				iconName={IconoirPlusCircle}
				onClick={() => setShowModal(!showModal)}
			/>
			{!disabled && (
				<CreateEditITProcessModalWrapper
					isManageEntities
					isCreate
					showModal={showModal}
					setShowModal={setShowModal}
					bodyId={bodyId}
					onSaveComplete={onSaveComplete}
				/>
			)}
		</StyledNewItProcessToolbarButton>
	);
}

NewItProcessToolbarButton.propTypes = {
	label: PropTypes.string.isRequired,
	className: PropTypes.string,
	disabled: PropTypes.bool
};

NewItProcessToolbarButton.defaultProps = {
	className: 'body-special-toolbar-button',
	disabled: false
};

const StyledNewItProcessToolbarButton = styled.section`
	display: flex;
	align-items: flex-end;
	margin-left: auto;
`;
